// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-oasis -> weidner-apartment-homes-oasis-oasis -> bolero
// Generated: 2026-10-29T20:20:40.167Z
// Counts: 0 design, 25 content, 21 slot group, 1 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactblock.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact our friendly leasing team at Bolero Apartments in Phoenix, AZ, for details on floor plans and amenities, or to schedule a tour. We're here to help you explore your options and make your next move simple.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h1><strong>Faq</strong></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore apartments for rent in Phoenix, AZ, at Bolero Apartments. Here, comfort meets convenience with modern finishes, stainless steel appliances, and in-unit laundry. Three resort-style pools offer an afternoon escape, while a spacious, pet-friendly, gated community creates space for connection. Just 15 minutes from downtown and close to Desert Sky Mall, you can unwind at home or enjoy Phoenix's vibrant neighborhood energy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.form_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>We'd love to hear from you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=160/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "tourblock.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Bolero Apartments in Phoenix, AZ, daily life is elevated with thoughtful in-home features and inviting community spaces. Enjoy relaxing by one of three sparkling pools, getting energized in two fitness centers, or unwinding in soothing spas. In your apartment, find comfort with walk-in closets, stainless steel appliances, an in-unit washer and dryer, and elegant finishes. It's easy to make each day feel just right.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Bolero Apartments in Phoenix, AZ, you'll find thoughtfully designed studios, one, two, and three-bedroom homes. Each layout includes welcoming features like walk-in closets, in-unit washer and dryer, and the potential for a cozy office nook or ample storage. Available garden tubs and granite countertops add a polished touch. Find the right fit for your daily routine, work-from-home setup, or entertaining space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>See what life looks like at Bolero Apartments in Phoenix, AZ. From sunlit kitchens to inviting community spaces, each photo lets you imagine relaxing by the pool with friends, enjoying spacious layouts, or gathering in open social areas. Flip through modern designs, cozy corners, and the warm, welcoming atmosphere that makes Bolero stand out.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeamenities.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Find studio, one, two, or three-bedroom floor plans that suit every lifestyle. Each apartment offers generous layouts with walk-in closets, garden tubs for relaxing soaks, and an in-home washer and dryer. Plenty of natural light and available wood floors add comfort whether you're working from home or hosting friends. Discover storage options, smart kitchen design, and a layout perfect for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeneighborhood.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Bolero places you near Ak Chin Pavilion, State Farm Stadium, and fantastic shopping and dining just two blocks away at Desert Sky Mall. Commute options are easy via bus routes and nearby highways. With local parks and entertainment, plus quick access to downtown, you'll find everyday inspiration right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeneighborhood.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Connected comfort near Desert Sky Mall and city vibes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Bolero Apartments puts you in the heart of Phoenix's Maryvale neighborhood. Shop at Desert Sky Mall, catch shows at Ak Chin Pavilion, or root for your favorite team at State Farm Stadium. With nearby bus routes, easy access to major roads, and parks close by, your Phoenix lifestyle is easy to enjoy. Dining, entertainment, and daily conveniences are all within reach - all from our address at 7725 W McDowell Rd, Phoenix, AZ 85035.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living in Maryvale - Phoenix, AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from live virtual tours or in-person guided visits at Bolero Apartments in Phoenix, AZ. Schedule a time that fits your vibe, whether you want to peek at floor plans or see the sparkling pools and fitness center. Opt for a virtual look from home, or explore in person with a leasing professional. Tour your way, on your schedule.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Bolero Apartments in Phoenix, AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore life at Bolero Apartments in Phoenix, AZ, with our virtual tour. Walk through bright kitchens and open living areas, and get a real feel for the community without leaving your sofa. Whether you're across town or out of state, our immersive tour lets you picture yourself at Bolero, helping you choose your ideal floor plan and see the atmosphere that makes this place unique.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "floorplanslist.card_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "propertyoverview.front_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "contactblock.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/user/WeidnerApartments"
      }
    }
  },
  "amenities-hero.collage_image_1": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "amenities-hero.collage_image_2": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "contactblock.hero_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "future-residents-club-hero.collage_image_1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "future-residents-club-hero.collage_image_2": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "gallery-hero.collage_image_1": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "gallery-hero.collage_image_2": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "interactive-map-hero.collage_image_1": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "interactive-map-hero.collage_image_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "neighborhood-hero.collage_image_1": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "neighborhood-hero.collage_image_2": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "pet-policy-hero.collage_image_1": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "pet-policy-hero.collage_image_2": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "resident-access-hero.collage_image_1": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "resident-access-hero.collage_image_2": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "tourblock.hero_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "virtual-tour-hero.collage_image_1": {
    "sourceIndex": 15,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": [
      "ec_2ebaff1b5f6eafa1e3d84b49",
      "ec_ab5f996f533afdb88068f5c9",
      "ec_253e468749ba7a7df0f44716",
      "ec_ab04295fe49a0289c28640a1",
      "ec_823c2b6566a7bee35205ba64",
      "ec_d3a4aeb0814656fc5c53f1b1",
      "ec_2052cc9223eee7dc372a5071",
      "ec_95f0e76a2d16b343cf75935b",
      "ec_8fe23a578e65617b58c607ef"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      2,
      4,
      6,
      9,
      12,
      13,
      5,
      8,
      14
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
